export default __webpack_public_path__ + "static/media/title_sp.54be74a9.png";